module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('span', {
    attrs: {
      "id": "qNote-on-the-text15"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapter-name sgc-1"
  }, [_c('span', [_vm._v("Note on the text")])]), _vm._v(" "), _c('p', {
    staticClass: "byline sgc-1"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "body_ni sgc-1"
  }, [_c('span', [_vm._v("I have made very minimal editorial changes to the text, respecting the conversational nature of Howard’s talks. If someone appears in the text by last name only, the index provides the full name. In the few instances when I have cut any text beyond a word that Howard himself corrected in a speech, I have noted the cut with ellipses. In a few cases where he clearly left out a word implied by the context, I have added it without the distraction of brackets.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fa13b16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Flow_0_0005.vue
// module id = 72
// module chunks = 0